// Application Configuration

// Determine the current environment
const env = import.meta.env.MODE || 'development';

// Get site URL from environment variable if available, otherwise use default for environment
const getSiteUrl = () => {
  // First priority: explicit environment variable
  if (import.meta.env.VITE_SITE_URL) {
    return import.meta.env.VITE_SITE_URL;
  }
  
  // Second priority: environment-specific defaults
  switch (env) {
    case 'development':
      return 'http://localhost:5173';
    case 'staging':
      return 'https://staging-lln.smit.edu.au';
    case 'production':
    default:
      return 'https://lln.smit.edu.au';
  }
};

// Configuration object with environment-specific settings
const config = {
  development: {
    appUrl: getSiteUrl(),
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
    supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
    enableConsoleLogs: import.meta.env.VITE_ENABLE_CONSOLE_LOGS === 'true',
    recaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
    recaptchaMinimumScore: parseFloat(import.meta.env.VITE_RECAPTCHA_MINIMUM_SCORE || '0.5'),
  },
  production: {
    appUrl: getSiteUrl(),
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
    supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
    enableConsoleLogs: import.meta.env.VITE_ENABLE_CONSOLE_LOGS === 'true',
    recaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
    recaptchaMinimumScore: parseFloat(import.meta.env.VITE_RECAPTCHA_MINIMUM_SCORE || '0.5'),
  },
  staging: {
    appUrl: getSiteUrl(),
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
    supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
    enableConsoleLogs: import.meta.env.VITE_ENABLE_CONSOLE_LOGS === 'true',
    recaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
    recaptchaMinimumScore: parseFloat(import.meta.env.VITE_RECAPTCHA_MINIMUM_SCORE || '0.5'),
  }
};

// Export the configuration for the current environment
export const appConfig = config[env as keyof typeof config];

// Export the site URL directly for easy access
export const siteUrl = getSiteUrl();

// Utility function to get the current environment
export const getEnvironment = () => env;

// Utility function to check if console logs should be enabled
export const shouldEnableConsoleLogs = (): boolean => {
  return appConfig.enableConsoleLogs;
};

// Utility function to check if we're in development mode
export const isDevelopment = (): boolean => {
  return env === 'development';
};

// Utility function to get reCAPTCHA configuration
export const getRecaptchaConfig = () => {
  return {
    siteKey: appConfig.recaptchaSiteKey,
    minimumScore: appConfig.recaptchaMinimumScore,
  };
};